export const STICKY_SEARCH_PARAM_KEY = 'sticky'

export const generateStickySearchParam = (param: string) => {
  const searchParam = new URLSearchParams()
  searchParam.set(STICKY_SEARCH_PARAM_KEY, param)
  return searchParam.toString()
}
